import Store from 'store/store';
import cached from 'utils/cached';
import { api } from 'utils/bolt/api';
import { accessNested } from 'utils/utils';

// Not waiting, we just want whatever is available
const currentLocationOptions = async () => {
	// Should we use geo from ip or the current location?
	// let geo = accessNested(Store.get(), 'client.geo') || {};
	// return { lat: geo.lat, lon: geo.lon };
	const geo = await geoFromIP();
	return { lat: geo.lat, lon: geo.lon };
};

// const getDefaultRegionBiasing = cached(() => {
// 	// let region = (await geoFromIP()).countryCode;
// 	let region = accessNested(Store.get(), 'appData.meta.region.slug');
// 	// Special cases (ccTLD, not ISO ; see https://developers.google.com/maps/documentation/geocoding/intro#RegionCodes)
// 	if (region === 'gb') {
// 		region = 'uk';
// 	}
// 	if (!/^[a-z]{2}$/.test(region)) {
// 		return;
// 	}
// 	return { region };
// });

export const geoFromIP = cached(async () => {
	let result = await fetch('https://stdata.powster.com/geo');
	let data = await result.json();
	if (data && data.countryCode) {
		data.countryCode = data.countryCode.toLowerCase();
	}
	return data;
});

export async function geoSearch(options) {
	options = Object.assign({}, await currentLocationOptions(), options);
	if (!options.search) {
		throw new Error('Searching with empty value');
	}
	
	const boundingRegions = accessNested(Store.get(), 'appData.pages.boltShowtimes.boundingRegions') || {};
	const appRegion = !Object.values(boundingRegions).some(v => !!v) && accessNested(Store.get(), 'appData.meta.region.slug');

	if (appRegion) {
		options.region = appRegion;
	}

	const data = await api('/geo/search', options);
	if (!data || !data.response) {
		throw new Error('Unable to search for ' + options.search);
	}
	return data.response;
}
export async function geoSearchOne(options) {
	let res = await geoSearch(options);
	if (!res || !res[0]) {
		throw new Error('No results for ' + options.search);
	}
	return res[0];
}